import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import './App.scss';
import {
    HashRouter as Router,
    Route,
} from "react-router-dom";
import PuzzleScreen from './app/components/puzzleScreen/PuzzleScreen.jsx';
import LeaderboardScore from './app/components/leaderboard/score/LeaderboardScore';
import LeaderboardTriangle from './app/components/leaderboard/triangle/LeaderboardTriangle';
import LeaderboardAverage from './app/components/leaderboard/average/LeaderboardAverage';
import EndGameTTB from './app/components/endGameScreen/endGameTTB/EndGameTTB';
import EndGameGeneric from './app/components/endGameScreen/endGameGeneric/EndGameGeneric';
import LandingScreen from './app/components/landingScreen/landingScreen';
import IntroductionScreen from './app/components/introductionScreen/introductionScreen';
import IntroductionPuzzleScreen from './app/components/introductionScreen/puzzle-screens/IntroductionPuzzleScreen';
import Warning from './app/components/warning/warning';
import gameSchema from './app/gameSchema';
// import TrackTheBall from './app/components/trackTheBall/track-the-ball';
// import TrackTheBallPhaser from './app/components/trackTheBall/trackTheBallPhaser';
// import TeamSnake from './app/components/teamSnake/TeamSnake.jsx';
// import FixTheMachine from './app/components/fixTheMachine/FixTheMachine';
// import FixTheMachineCalibration from './app/components/fixTheMachine/FixTheMachineCalibration';
// import EndGameScore from './app/components/endGameScore/endGameScore';
// import Sensors from './app/components/sensors/Sensors';
// import Feedstock from './app/components/feedstock/Feedstock';
// import SatelliteImages from './app/components/satelliteImages/SatelliteImages';
// import IntroductionTeamSnake from './app/components/introductionScreen/team-snake/IntroductionTeamSnake';
// import IntroductionFixTheMachine from './app/components/introductionScreen/fix-the-machine/IntroductionFixTheMachine';
// import TrackTheBallOnboarding from './app/components/introductionScreen/track-the-ball/TrackTheBallOnboarding';
// import { loadWebcam } from './app/components/fixTheMachine/libs/functions';

const App = ( { config }) => {
    const [redirect, setRedirect] = useState(false);
    const [showWarning, setShowWarning] = useState(false);

    // Load non-user-editable game data
    const gameData = gameSchema[config.game];

    // useEffect(() => {
    //     if (config.game === 'fixTheMachine') {
    //         loadWebcam()
    //     }
    //     // eslint-disable-next-line
    // }, [])


    /*
    * --------------------------------------------------
    * Loading specific component types depending on game
    * --------------------------------------------------
    */
    const leaderboardComponents = {
        score: LeaderboardScore,
        triangle: LeaderboardTriangle,
        average: LeaderboardAverage
    };

    let Leaderboard = null;
    if (gameData.components.leaderboard) {
        Leaderboard = leaderboardComponents[gameData.components.leaderboard];
    }

    // -------------------------------------------------

    const introductionComponents = {
        puzzleScreen: IntroductionPuzzleScreen,
        // teamSnake: IntroductionTeamSnake,
        sensors: IntroductionScreen,
        // trackTheBall: TrackTheBallOnboarding,
        // fixTheMachine: IntroductionFixTheMachine,
    };

    let Introduction = null;
    if (introductionComponents[config.game]) {
        Introduction = introductionComponents[config.game];
    }

    // -------------------------------------------------

    const gameComponents = {
        // trackTheBall: TrackTheBallPhaser,
        puzzleScreen: PuzzleScreen,
        // sensors: Sensors,
        // feedstock: Feedstock,
        // teamSnake: TeamSnake,
        // satelliteImages: SatelliteImages,
        // fixTheMachine: FixTheMachine,
    };

    let GameComponent = null;
    if (gameComponents[config.game]) {
        GameComponent = gameComponents[config.game];
    }

    // -------------------------------------------------

    const endComponents = {
        trackTheBall: EndGameTTB,
        teamSnake: EndGameGeneric,
    };
    let EndGame = null;
    if (endComponents[config.game]) {
        EndGame = endComponents[config.game];
    }

    // -------------------------------------------------

    const getRefsFromChild = (redirect, showWarning) => {
        redirect ? setRedirect(true) : setRedirect(false);
        showWarning ? setShowWarning(true) : setShowWarning(false);
    };

    return (
        <Router>
            <div className={`App ${gameData.gameClass}`}>

                {config.game === 'fixTheMachine' &&
                    <div className="webcam-overlay hide">
                        <video className="webcam" id="webcam"></video>

                        <div className='black-bg' style={{
                            opacity: config.overlay_opacity
                        }}>
                            <svg width="1080" height="1920">
                                <defs>
                                    <filter height="200%" width="200%" y="-50%" x="-50%" id="gaussian_blur">
                                        <feGaussianBlur stdDeviation="10" in="SourceGraphic"/>
                                    </filter>
                                    <mask id="mask-svg">
                                        <rect fill="#fff" id="canvas-background" height="1922" width="1082" y="-1" x="-1"/>
                                        <ellipse filter="url(#gaussian_blur)" ry="100" rx="100" id="circle-1" cx="0" cy="0" fill="#fff"/>
                                        <ellipse filter="url(#gaussian_blur)" ry="100" rx="100" id="circle-2" cx="0" cy="0" fill="#fff"/>
                                    </mask>
                                </defs>
                                <rect width="100%" height="100%" style={{ fill: '#000' }} mask="url(#mask-svg)"></rect>
                            </svg>
                        </div>
                    </div>
                }

                <CSSTransition appear in={showWarning} classNames="fade" timeout={{enter: 600, exit: 300}} unmountOnExit>
                    <Warning config={config} gameData={gameData} appRedirect={redirect} appWarning={showWarning} />
                </CSSTransition>

                <Route path={`/executables/${gameData.gameClass}/attractor`}>
                    {({match}) => (
                        <CSSTransition in={match !== null} classNames="fade" timeout={{enter: 600, exit: 300}} unmountOnExit={true}>
                            <GameComponent config={config} gameData={gameData} passRefUpward={getRefsFromChild} />
                        </CSSTransition>
                    )}
                </Route>

                <Route exact path="/">
                    {({match}) => (
                        <CSSTransition appear in={match !== null} classNames="fade" timeout={{enter: 600, exit: 300}} unmountOnExit>
                            <LandingScreen config={config} gameData={gameData} passRefUpward={getRefsFromChild} />
                        </CSSTransition>
                    )}
                </Route>

                { Introduction !== null &&
                    <Route exact path="/introduction">
                        {({match}) => (
                            <CSSTransition appear in={match !== null} classNames="fade" timeout={{enter: 600, exit: 300}} unmountOnExit>
                                <Introduction config={config} gameData={gameData} passRefUpward={getRefsFromChild} />
                            </CSSTransition>
                        )}
                    </Route>
                }

                { Leaderboard !== null &&
                    <Route exact path="/leaderboard">
                        {({match}) => (
                            <CSSTransition appear in={match !== null} classNames="fade" timeout={{enter: 600, exit: 300}} unmountOnExit>
                                <Leaderboard config={config} gameData={gameData} passRefUpward={getRefsFromChild} />
                            </CSSTransition>
                        )}
                    </Route>
                }

                {config.screens.endGameScore && EndGame !== null &&
                    <Route exact path="/endgamescore">
                        {({match}) => (
                            <CSSTransition appear in={match !== null} classNames="fade" timeout={{enter: 600, exit: 300}} unmountOnExit>
                                <EndGame config={config} gameData={gameData} passRefUpward={getRefsFromChild} />
                            </CSSTransition>
                        )}
                    </Route>
                }

                {/* {config.game === 'fixTheMachine' &&
                    <Route exact path="/calibration">
                        <FixTheMachineCalibration config={config} gameData={gameData} passRefUpward={getRefsFromChild} />
                    </Route>
                } */}

                <a href={config.startUrl} className="attractor-reset"> </a>

            </div>
        </Router>
    );

};

export default App;
